import DataStoreMock from './base/data-store';
import { PermissionSummary } from 'src/stores/permissions-store';
import { Query } from '@testing-library/react';
import { PermissionSummaryMockData } from '../data-sources/permission-summary';

export class PermissionSummaryStoreMock extends DataStoreMock<PermissionSummary> {
  public async loadPermissions(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: PermissionSummaryMockData,
      count: PermissionSummaryMockData.length,
    });
    return PermissionSummaryMockData;
  }
}
